import { useMemo } from 'react'

import { useChainId } from 'wagmi'

import { CHAIN_INFO } from 'constants/chains'
import { ETH_ADDRESS } from 'constants/addresses'

export function useNativeCurrency() {
  const chainId = useChainId()

  const chainInfo = useMemo(() => CHAIN_INFO[chainId], [chainId])

  return useMemo(
    () => ({
      decimals: 18,
      name: chainInfo.name,
      symbol: chainInfo.symbol,
      address: ETH_ADDRESS,
    }),
    [chainInfo],
  )
}
